<template>
  <DeepDialog
    v-model="dialog"
    fullscreen-on-mobile
    :title="i18n.t('texts.reject_signature_process')"
    width="600"
    @keydown.esc="() => (dialog = false)"
  >
    <template #content>
      <v-card-text class="pa-0 text-black text-left mb-6">
        {{ i18n.t('text.reject_signature_process_subtitle') }}
      </v-card-text>
      <div class="text-body-medium text-medium-emphasis mb-1">
        {{ i18n.t('titles.reject_signature_process_text') }}
      </div>
      <v-textarea
        ref="feedbackMessage"
        v-model="comment"
        data-test-id="dialog-describe"
        name="field-feedback-message"
        :placeholder="i18n.t('placeholders.reject_signature_process')"
        :resizable="false"
        variant="outlined"
      />
    </template>
    <template #actions>
      <VBtnSecondary
        data-test-id="dialog-cancel"
        :text="i18n.t('buttons.cancel')"
        variant="outlined"
        @click="cancelRejection"
      />
      <VBtnPrimary
        color="primary"
        data-test-id="dialog-reject"
        :text="i18n.t('buttons.reject_now')"
        @click="handleRejection"
      />
    </template>
  </DeepDialog>
</template>

<script setup lang="ts">
import { DeepDialog } from '@deepcloud/deep-ui-lib';
import { useEmitter } from '@/composables/useEmitter';
import { onUnmounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useSignStore } from '@/stores/sign.ts';
import { useRouter } from 'vue-router';
import AuthService from '@/services/authService.ts';

const i18n = useI18n();
const emitter = useEmitter();
const dialog = ref(false);
const isApproverCase = ref(false);
const comment = ref();
const signStore = useSignStore();
const router = useRouter();

emitter.$on('open-reject-signature-process-dialog', openDialog);

onUnmounted(() => {
  emitter.$off('open-reject-signature-process-dialog', openDialog);
});

function openDialog(approverValue: boolean = false) {
  dialog.value = true;
  isApproverCase.value = approverValue;
}

function handleRejection() {
  if (signStore.document?.signContext.signKey) {
    signStore
      .rejectSignature(
        {
          comment: comment.value
        },
        signStore.document!.documentId,
        isApproverCase.value
      )
      .then(() => {
        if (AuthService.isAuthenticated) {
          router.push(`/document/${signStore.document?.documentId}/details`);
          emitter.$emit('update-sign-status');
          cancelRejection();
        } else {
          window.location.reload();
          cancelRejection();
        }
      });
  } else {
    console.error(
      'There was no SignKey provided for rejecting the signature process'
    );
  }
}

function cancelRejection() {
  dialog.value = false;
  comment.value = undefined;
}
</script>

<style lang="scss" scoped>
.card-title {
  word-break: break-word;
  font-weight: 600;
  font-size: 24px !important;
  text-align: center;
  margin: 0 0 30px;
  white-space: normal;
}
</style>
